export default __webpack_public_path__ + "static/Merriweather-Bold-26b65b4c885fec072584bc2764f786cb.woff2";